<mobi-breadcrumb />

<mobi-hero-text
  [superTitle]="entity().superTitle"
  [title]="entity().title"
  [lead]="entity().lead"
  [isCentered]="true"
/>
<div class="overflow-hidden xsMax:full-bleed">
  <div class="project-overview-hero view-enter-animation">
    @if (breakpoint.mdAndLarger()) {
      <div class="mobi-ui-grid hero-images-md">
        <div class="items-end mobi-ui-col-1/6 mobi-ui-flex !mb-0">
          @if (entity().imagesHeaderSquare && entity()?.imagesHeaderSquare?.[0]) {
            <div class="aspect-1 hero-image-animation-wrapper">
              <mobi-media
                [animation]="false"
                class="mobi-ui-animation-appear-left-init mobi-ui-animation-appear-left-render is-delayed-300"
                responsiveStyle="hero_seven_square"
                [entity]="entity()?.imagesHeaderSquare?.[0]"
                [rounded]="breakpoint.smMax() ? 'right' : 'full'"
              />
            </div>
          }
        </div>
        <div class="flex-col justify-end mobi-ui-col-1/6 mobi-ui-flex !mb-0">
          @if (entity().imagesHeaderLandscape && entity()?.imagesHeaderLandscape?.[0]) {
            <div class="hero-image-animation-wrapper has-margin-b">
              <mobi-media
                [animation]="false"
                class="mobi-ui-animation-appear-left-init mobi-ui-animation-appear-left-render is-delayed-300"
                responsiveStyle="hero_seven_landscape"
                [entity]="entity()?.imagesHeaderLandscape?.[0]"
                [rounded]="breakpoint.smMax() ? 'none' : 'full'"
              />
            </div>
          }
          @if (entity().imagesHeaderSquare && entity()?.imagesHeaderSquare?.[1]) {
            <div class="aspect-1 hero-image-animation-wrapper">
              <mobi-media
                [animation]="false"
                class="mobi-ui-animation-appear-left-init mobi-ui-animation-appear-left-render is-delayed-300"
                responsiveStyle="hero_seven_square"
                [entity]="entity()?.imagesHeaderSquare?.[1]"
                [rounded]="breakpoint.smAndLarger() ? 'left' : 'full'"
              />
            </div>
          }
        </div>
        <div class="items-end mobi-ui-col-2/6 mobi-ui-flex !mb-0">
          @if (entity().imageHeaderBig) {
            <div class="hero-image-animation-wrapper">
              <mobi-media
                [animation]="false"
                class="mobi-ui-animation-appear-left-init mobi-ui-animation-appear-left-render is-delayed-300"
                [entity]="entity().imageHeaderBig"
                responsiveStyle="hero_seven_big"
                [rounded]="breakpoint.smAndLarger() ? 'none' : 'full'"
                [lazy]="false"
              />
            </div>
          }
        </div>
        <div class="flex-col justify-end mobi-ui-col-1/6 mobi-ui-flex !mb-0">
          @if (entity().imagesHeaderSquare && entity()?.imagesHeaderSquare?.[2]) {
            <div class="aspect-1 hero-image-animation-wrapper has-margin-b">
              <mobi-media
                [animation]="false"
                class="mobi-ui-animation-appear-left-init mobi-ui-animation-appear-left-render is-delayed-300"
                responsiveStyle="hero_seven_square"
                [entity]="
                  entity().imagesHeaderSquare && entity()?.imagesHeaderSquare?.[2]
                "
                [rounded]="breakpoint.smAndLarger() ? 'left' : 'full'"
              />
            </div>
          }
          @if (entity().imagesHeaderLandscape && entity()?.imagesHeaderLandscape?.[1]) {
            <div class="hero-image-animation-wrapper">
              <mobi-media
                [animation]="false"
                class="mobi-ui-animation-appear-left-init mobi-ui-animation-appear-left-render is-delayed-300"
                responsiveStyle="hero_seven_landscape"
                [entity]="entity()?.imagesHeaderLandscape?.[1]"
                [rounded]="breakpoint.smAndLarger() ? 'none' : 'full'"
              />
            </div>
          }
        </div>
        <div class="items-end mobi-ui-col-1/6 mobi-ui-flex !mb-0">
          @if (entity().imagesHeaderSquare && entity()?.imagesHeaderSquare?.[3]) {
            <div class="aspect-1 hero-image-animation-wrapper">
              <mobi-media
                [animation]="false"
                class="mobi-ui-animation-appear-left-init mobi-ui-animation-appear-left-render is-delayed-300"
                responsiveStyle="hero_seven_square"
                [entity]="
                  entity().imagesHeaderSquare && entity()?.imagesHeaderSquare?.[3]
                "
                [rounded]="breakpoint.smAndLarger() ? 'left' : 'full'"
              />
            </div>
          }
        </div>
      </div>
    }
    @if (breakpoint.smMax()) {
      <div class="hero-images-sm">
        @for (
          image of entity().imagesHeaderSquare;
          track image?.uuid ?? $index;
          let i = $index
        ) {
          <div [class]="'aspect-3/2 hero-image-animation-wrapper img-square-' + (i + 1)">
            <mobi-media
              [animation]="false"
              class="mobi-ui-animation-appear-left-init mobi-ui-animation-appear-left-render is-delayed-300 aspect-3/2"
              [entity]="image"
              [class]="'img-square-' + (i + 1)"
              responsiveStyle="hero_seven_square"
            />
          </div>
        }
        <div class="hero-image-animation-wrapper img-large">
          <mobi-media
            [animation]="false"
            class="mobi-ui-animation-appear-left-init mobi-ui-animation-appear-left-render is-delayed-300 img-large"
            [entity]="entity().imageHeaderBig"
            responsiveStyle="hero_seven_big"
            [lazy]="false"
          />
        </div>
      </div>
    }
  </div>
</div>
<div class="page-content">
  @if (entity().recommendations && entity().recommendations?.length) {
    <div class="content-section">
      <div class="view-enter-animation">
        <mobi-recommendations
          [title]="entity().recommendationsTitle"
          [description]="entity().recommendationsSubtitle || ''"
          [recommendations]="entity().recommendations ?? []"
        />
      </div>
    </div>
  }

  @if (hasTeasers(entity().teasersRegular)) {
    <ng-container
      [ngTemplateOutlet]="teaserRegular"
      [ngTemplateOutletContext]="{
        title: entity().teaserSectionTitle,
        subtitle: entity().teaserSectionSubtitle,
        text: entity().teasersSectionText ?? '',
        teasers: entity().teasersRegular,
      }"
    ></ng-container>
  }
  @if (hasTeasers(entity().teasersSmall)) {
    <ng-container
      [ngTemplateOutlet]="teaserSmall"
      [ngTemplateOutletContext]="{
        title: entity().teaserSectionSmallTitle,
        description: entity().teaserSectionSmallDescription,
        teasers: entity().teasersSmall,
      }"
    ></ng-container>
  }
  @if (hasTeasers(entity().teasers2Regular)) {
    <ng-container
      [ngTemplateOutlet]="teaserRegular"
      [ngTemplateOutletContext]="{
        title: entity().teaser2SectionTitle,
        subtitle: entity().teaser2SectionSubtitle,
        text: entity().teasers2SectionText ?? '',
        teasers: entity().teasers2Regular,
      }"
    ></ng-container>
  }
  @if (hasTeasers(entity().teasers2Small)) {
    <ng-container
      [ngTemplateOutlet]="teaserSmall"
      [ngTemplateOutletContext]="{
        title: entity().teaser2SectionSmallTitle,
        description: entity().teaser2SectionSmallDescription,
        teasers: entity().teasers2Small,
      }"
    ></ng-container>
  }
  @if (hasTeasers(entity().teasers3Regular)) {
    <ng-container
      [ngTemplateOutlet]="teaserRegular"
      [ngTemplateOutletContext]="{
        title: entity().teaser3SectionTitle,
        subtitle: entity().teaser3SectionSubtitle,
        text: entity().teasers3SectionText ?? '',
        teasers: entity().teasers3Regular,
      }"
    ></ng-container>
  }
  @if (hasTeasers(entity().teasers3Small)) {
    <ng-container
      [ngTemplateOutlet]="teaserSmall"
      [ngTemplateOutletContext]="{
        title: entity().teaser3SectionSmallTitle,
        description: entity().teaser3SectionSmallDescription,
        teasers: entity().teasers3Small,
      }"
    ></ng-container>
  }
  @if (hasTeasers(entity().teasers4Regular)) {
    <ng-container
      [ngTemplateOutlet]="teaserRegular"
      [ngTemplateOutletContext]="{
        title: entity().teaser4SectionTitle,
        subtitle: entity().teaser4SectionSubtitle,
        text: entity().teasers4SectionText ?? '',
        teasers: entity().teasers4Regular,
      }"
    ></ng-container>
  }
  @if (hasTeasers(entity().teasers4Small)) {
    <ng-container
      [ngTemplateOutlet]="teaserSmall"
      [ngTemplateOutletContext]="{
        title: entity().teaser4SectionSmallTitle,
        description: entity().teaser4SectionSmallDescription,
        teasers: entity().teasers4Small,
      }"
    ></ng-container>
  }
  @if (hasTeasers(entity().teasers5Regular)) {
    <ng-container
      [ngTemplateOutlet]="teaserRegular"
      [ngTemplateOutletContext]="{
        title: entity().teaser5SectionTitle,
        subtitle: entity().teaser5SectionSubtitle,
        text: entity().teasers5SectionText ?? '',
        teasers: entity().teasers5Regular,
      }"
    ></ng-container>
  }
  @if (hasTeasers(entity().teasers5Small)) {
    <ng-container
      [ngTemplateOutlet]="teaserSmall"
      [ngTemplateOutletContext]="{
        title: entity().teaser5SectionSmallTitle,
        description: entity().teaser5SectionSmallDescription,
        teasers: entity().teasers5Small,
      }"
    ></ng-container>
  }

  @if (entity().teasersTopic && entity().teasersTopic?.length) {
    <mobi-content-section [content]="topics" [background]="true">
      <ng-template #topics>
        <div class="mobi-ui-grid mobi-ui-ink-blue smMax:!gap-y-0 heading-spacing-before">
          <div class="mobi-ui-col-1/1 md:mobi-ui-col-3/8 view-enter-animation">
            @if (entity().teasersTopicTitle) {
              <h2 class="mobi-ui-font-size-650">
                {{ entity().teasersTopicTitle }}
              </h2>
            }
            @if (!entity().teasersTopicTitle) {
              <h3 class="mobi-ui-font-h5">
                {{ 'topics' | texts: { context: 'frontend', default: 'Themenseiten' } }}
              </h3>
            }
            @if (entity().teasersTopicText) {
              <mobi-text
                [data]="entity().teasersTopicText ?? ''"
                class="mobi-ui-font-size-150 block"
              />
            }
          </div>
          <div class="mobi-ui-col-1/1 md:mobi-ui-col-5/8">
            @for (teaser of entity().teasersTopic; track teaser.id) {
              @if (teaser) {
                <div class="view-enter-animation">
                  <div class="mobi-ui-separator-minor"></div>
                  <mobi-teaser
                    [bundle]="teaser.bundle"
                    [published]="teaser.published"
                    [teaserIllustration]="teaser.teaserIllustration"
                    [teaserImage]="teaser.teaserImage"
                    [teaserText]="teaser.teaserText"
                    [teaserTitle]="teaser.teaserTitle"
                    [teaserUrl]="teaser.url | extractUrl"
                    [teaserStyle]="teaserStyle"
                    [secondaryActionUrl]="
                      teaser.calculatorCta
                        | extractUrl
                        | calcUrl: (teaser.calculatorCtaAuth | extractUrl)
                    "
                    [secondaryActionTarget]="
                      teaser.calculatorCta?.options?.attributes?.target
                    "
                    [secondaryActionText]="teaser.calculatorCta?.title"
                    secondaryActionIcon="calculator"
                    teaserTitleStyle="h5"
                    class="mobi-prover-topics-teaser"
                  ></mobi-teaser>
                </div>
              }
            }
            <div class="mobi-ui-separator-minor"></div>
          </div>
        </div>
      </ng-template>
    </mobi-content-section>
  }

  <ng-template
    let-title="title"
    let-subtitle="subtitle"
    let-text="text"
    let-teasers="teasers"
    #teaserRegular
  >
    <mobi-content-section [content]="productsLarge">
      <ng-template #productsLarge>
        <div class="view-enter-animation mobi-ui-margin-b-md">
          @if (title) {
            <h2>{{ title }}</h2>
          }
          @if (subtitle) {
            <h3 class="mobi-ui-font-size-200 mobi-ui-font-h4 !mt-0">
              {{ subtitle }}
            </h3>
          }
          @if (text) {
            <mobi-text [data]="text" class="mobi-ui-font-size-150 block" />
          }
        </div>
        <mobi-teaser-list [teasers]="teasers" [isMobileSlider]="false" />
      </ng-template>
    </mobi-content-section>
  </ng-template>

  <ng-template
    let-title="title"
    let-description="description"
    let-teasers="teasers"
    #teaserSmall
  >
    <mobi-content-section [content]="productsSmall" class="block mobi-ui-padding-y-lg">
      <ng-template #productsSmall>
        <div class="mobi-ui-grid heading-spacing-before !pb-0 smMax:!gap-y-[12px]">
          <div class="mobi-ui-col-1/1 md:mobi-ui-col-1/3 view-enter-animation">
            @if (title) {
              <h3 class="mobi-ui-text-inked">
                {{ title }}
              </h3>
            }
            @if (description) {
              <mobi-text [data]="description" class="mobi-ui-font-size-150 block" />
            }
          </div>
          <div class="mobi-ui-col-1/1 md:mobi-ui-col-2/3">
            <div class="mobi-ui-grid">
              @for (teaser of teasers; track teaser?.id) {
                @if (teaser) {
                  <mobi-teaser
                    [published]="teaser.published"
                    [teaserTitle]="teaser.teaserTitle"
                    [teaserText]="teaser.teaserText"
                    [teaserIllustration]="teaser.teaserIllustration"
                    [teaserUrl]="teaser.url | extractUrl"
                    teaserStyle="small"
                    class="mobi-ui-col-1/1 md:mobi-ui-col-1/2"
                    [trackingId]="teaser.uuid"
                  />
                }
              }
            </div>
          </div>
        </div>
      </ng-template>
    </mobi-content-section>
  </ng-template>
</div>
